<script>
    export let style
</script>

<div style="--width:{style.width};--height:{style.height};--mbWidth:{style.mbWidth};--mbHeight:{style.mbHeight}" >    
    <slot />
</div>
<style>
    div{
        border-radius: 10px;
        background: #fff;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        display: flex;
        width:var(--width);
        height:var(--height);
        box-sizing: border-box;
    }
    @media screen and (max-width:640px){
        div{
            width:var(--mbWidth);
            height:var(--mbHeight);
        }
    }
</style>

